
namespace TabAurous.Reports {

    @Serenity.Decorators.registerClass()
    export class TrialBalanceGrid extends Serenity.EntityGrid<TabAurous.OMS.LedgerPostingRow, any> {
        protected getColumnsKey() { return 'OMS.TrialBalance'; }
        protected getDialogType() { return TabAurous.OMS.LedgerPostingDialog; }
        protected getIdProperty() { return TabAurous.OMS.LedgerPostingRow.idProperty; }
        protected getInsertPermission() { return TabAurous.OMS.LedgerPostingRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.OMS.LedgerPostingRow.localTextPrefix; }
        protected getService() { return TabAurous.OMS.TrialBalanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            //let x;
            //OMS.LedgerPostingService.CustomList({},
            //    response =>
            //        x = response,
            //    { async: false });

            //let check = false;
            //for (let item of x.Entities) {
            //    item[this.getIdProperty()] = item.LedgerPostingId;
            //    check = true;
            //    this.view.addItem(item);
            //}
            ////grid.setData(x1, true);
            ////var c = grid.getData();
            //if (!check) {
            //    this.view.setItems([], true);
            //}
            this.view.setGrouping([{ getter: 'Nature' }])
            return grid;
        }
        //protected getQuickFilters() {
        //    var filters = super.getQuickFilters();

        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: OMS.FinancialYearRow.lookupKey,
        //            multiple: true

        //        },
        //        field: 'FinancialYearId',
        //        title: 'Year',
        //        handler: w => {
        //            var temp = [];
        //            var values = w.value;
        //            for (var i = 0; i < values.length; i++) {
        //                temp.push(parseInt(values[i]));
        //            } if (temp.length != 0) {
        //                (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
        //                //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
        //                //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
        //            }
        //        },

        //        cssClass: 'hidden-xs'
        //    });
        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: OMS.CompanyRow.lookupKey,
        //            multiple: true

        //        },
        //        field: 'CompanyId',
        //        title: 'Company',
        //        handler: w => {
        //            var temp = [];
        //            var values = w.value;
        //            for (var i = 0; i < values.length; i++) {
        //                temp.push(parseInt(values[i]));
        //            } if (temp.length != 0) {
        //                (this.view.params as ReportFiltersRequest).CompanyIds = temp;
        //            }
        //        },

        //        cssClass: 'hidden-xs'
        //    });
        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: "VendorLKUP",
        //            multiple: true

        //        },
        //        field: 'PartyId',
        //        title: 'Party',
        //        handler: w => {
        //            var temp = [];
        //            var values = w.value;
        //            for (var i = 0; i < values.length; i++) {
        //                temp.push(parseInt(values[i]));
        //            } if (temp.length != 0) {
        //                (this.view.params as ReportFiltersRequest).VendorIds = temp;
        //            }
        //        },

        //        cssClass: 'hidden-xs'
        //    });


        //    return filters;
        //}
        protected usePager() { return false; };
        
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Finance.TrialBalance',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }
    }
}